import type { CommunityNotificationSettings } from 'models';

export const isChangeAllowed = ({
  notificationEntity,
  notificationSettings,
  notificationType,
}: {
  notificationEntity: 'events' | 'giving' | 'newsfeed' | 'program';
  notificationSettings: CommunityNotificationSettings;
  notificationType: 'emailNotificationsSettings' | 'pushNotificationsSettings';
}) => notificationSettings[notificationType][notificationEntity].changeAllowed;
